export enum AlertActionTypes {
  GET_ALERTS = "@@ALERT/GET_ALERTS",
  GET_ALERTS_SUCCESS = "@@ALERT/GET_ALERTS_SUCCESS",
  GET_ALERTS_FAILURE = "@@ALERT/GET_ALERTS_FAILURE",

  CREATE_ALERT = "@@ALERT/CREATE_ALERT",
  CREATE_ALERT_SUCCESS = "@@ALERT/CREATE_ALERT_SUCCESS",
  CREATE_ALERT_FAILURE = "@@ALERT/CREATE_ALERT_FAILURE",

  CREATE_USER_ALERT = "@@ALERT/CREATE_USER_ALERT",
  CREATE_USER_ALERT_SUCCESS = "@@ALERT/CREATE_USER_ALERT_SUCCESS",
  CREATE_USER_ALERT_FAILURE = "@@ALERT/CREATE_USER_ALERT_FAILURE",

  CLEAR_ALERTS = "@@ALERT/CLEAR_ALERTS",

  GET_ALERT_NOTIFICATIONS = "@@ALERT/GET_ALERT_NOTIFICATIONS",
  GET_ALERT_NOTIFICATIONS_SUCCESS = "@@ALERT/GET_ALERT_NOTIFICATIONS_SUCCESS",
  GET_ALERT_NOTIFICATIONS_FAILURE = "@@ALERT/GET_ALERT_NOTIFICATIONS_FAILURE",

  READ_ALERT_NOTIFICATION = "@@ALERT/READ_ALERT_NOTIFICATION",
  READ_ALERT_NOTIFICATION_SUCCESS = "@@ALERT/READ_ALERT_NOTIFICATION_SUCCESS",
  READ_ALERT_NOTIFICATION_FAILURE = "@@ALERT/READ_ALERT_NOTIFICATION_FAILURE",

  SET_FILTER = "@@ALERT/SET_FILTER",
}
